export type Environment = 'production' | 'staging'

export const isDev = () =>
  Boolean(typeof document !== 'undefined' && document.location.href.startsWith('http://localhost:'))

export const isTest = () =>
  Boolean(typeof process !== 'undefined' && (process.env.NODE_ENV === 'test' || Boolean(process.env.VITEST)))
